import React, { useState, useEffect, useRef } from 'react'
import ksuLogo from '../../assets/images/ksu-logo.png'
import { Link, NavLink } from 'react-router-dom'
import tamken from '../../assets/images/tamken.png'


export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isMediaDropdownOpen, setIsMediaDropdownOpen] = useState(false)
  const [showScrollTop, setShowScrollTop] = useState(false)
  const dropdownRef = useRef(null)
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })
  const handleNavClick = () => {
    scrollToTop()
    setIsMobileMenuOpen(false)
  }

  const getCategoryBackgroundColor = (category) => {
    switch (category) {
      case 'الكل':
        return 'bg-[#0084bd]';
      case 'أعضاء هيئة التدريس':
        return 'bg-[#673171]';
      case 'موظفين':
        return 'bg-[#006B9D]';
      case 'طلاب':
        return 'bg-[#009881]';
      case 'قيادات':
        return 'bg-[#323333]';
      default:
        return 'bg-[#0098DA]';
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsMediaDropdownOpen(false)
      }
    }

    if (isMediaDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isMediaDropdownOpen])

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 200)
    }
    window.addEventListener('scroll', handleScroll)
    handleScroll()
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  return (
    <>
      {/* Main Navbar */}
      <div className={`fixed top-0 left-0 bg-white text-black right-0 z-[60] flex justify-between items-center py-2 px-4 md:px-8 lg:px-12 transition-colors duration-300`}>
        <div className='flex items-center gap-4 md:gap-7'>
          <div className='w-[120px] md:w-[140px] lg:w-[157px]'>
            <Link to='/' onClick={handleNavClick}>
              <img src={ksuLogo} alt='ksu logo' className='w-full' />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <div className='hidden lg:block'>
            <ul className='flex flex-wrap items-center gap-4 md:text-sm'>
              {[
                { to: '/', label: 'الرئيسية' },
                { to: '/day', label: 'برنامج الملتقى' },
                { to: '/workshops', label: 'ورش العمل' },
                { to: '/dialogue-sessions', label: 'الجلسات الحوارية' },
                { to: '/rate', label: 'رأيك يهمنا' },
                { to: '/career-guidance', label: 'جلسات الارشاد المهني' },
                { to: '/contact', label: 'تواصل معنا' },
                // { to: '/skill-quest', label: 'اكتشف مهاراتك' },
              ].map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    className={({ isActive }) =>
                      `relative inline-flex items-center text-base px-1 py-1 transition-colors duration-200 text-semibold ${
                        isActive ? '' : 'text-slate-900 hover:text-[#0084BD]'
                      } after:absolute after:left-0 after:bottom-0 after:h-[2px] after:bg-[#0084BD] after:transition-all after:duration-300 ${
                        isActive ? 'after:w-full' : 'after:w-0 hover:after:w-full'
                      }`
                    }
                  onClick={handleNavClick}
                >
                    {item.label}
                  </NavLink>
                </li>
              ))}
              {/* <li>
                <a target='_blank' href='https://tamkeenx.eventfull.sa/register' onClick={handleNavClick} className='relative inline-flex items-center text-lg px-1 py-1 transition-colors duration-200 text-semibold'>
                  التسجيل
                </a>
              </li> */}
            </ul>
          </div>
        </div>
        <div className='w-[70px]'>
          <img src={tamken} alt='tamken logo' className='w-full' />
        </div>
        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className='lg:hidden p-2 text-[#0084BD] hover:bg-white/10 rounded-md transition-colors'
          aria-label='Toggle mobile menu'
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            {isMobileMenuOpen ? (
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            ) : (
              <path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Side Menu */}
      <div className={`lg:hidden fixed left-0 right-0 top-[64px] z-50 max-h-[calc(100vh-64px)] transform transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-y-0 pointer-events-auto' : '-translate-y-full pointer-events-none'} bg-[#0084BD] shadow-xl`}>
        <div className='flex flex-col h-full py-6 px-6 text-white'>
          {/* <div className='flex items-center justify-between mb-4'>
            <span className='text-lg font-semibold'>القائمة</span>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className='p-2 rounded-md text-white hover:bg-white/10 transition-colors'
              aria-label='Close mobile menu'
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div> */}


          {/* Mobile Navigation */}
          <nav className='flex-1 overflow-y-auto'>
            <ul className='text-lg space-y-1'>
              {[
                { to: '/', label: 'الرئيسية' },
                { to: '/day', label: 'برنامج الملتقى' },
                { to: '/workshops', label: 'ورش العمل' },
                { to: '/dialogue-sessions', label: 'الجلسات الحوارية' },
                { to: '/rate', label: 'رأيك يهمنا' },
                { to: '/career-guidance', label: 'جلسات الارشاد المهني' },
                { to: '/contact', label: ' تواصل معنا' },
                // { to: '/skill-quest', label: 'اكتشف مهاراتك' },
              ].map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    onClick={handleNavClick}
                    className={({ isActive }) =>
                      `relative block py-3 px-4 rounded-md transition-colors font-semibold ${
                        isActive ? 'text-white' : 'text-white hover:text-white/90'
                      } after:absolute after:left-0 after:bottom-2 after:h-[2px] after:bg-white after:transition-all after:duration-300 ${
                        isActive ? 'after:w-full' : 'after:w-0 hover:after:w-full'
                      }`
                    }
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
              {/* <li>
                <a target='_blank' href='https://tamkeenx.eventfull.sa/register' onClick={handleNavClick} className='relative block py-3 px-4 rounded-md transition-colors font-semibold'>
                  التسجيل
                </a>
                </li> */}
            </ul>
          </nav>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/50 z-40"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Scroll To Top Button */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-5 right-5 z-[70] bg-[#0084BD] text-white p-3 rounded-full shadow-lg border-2 border-[#0084BD] transition-all duration-300 transform ${showScrollTop ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'} hover:bg-white hover:text-[#0084BD] hover:scale-105 hover:-translate-y-0.5`}
        aria-label="Scroll to top"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 19V5M12 5L6 11M12 5L18 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </>)
}
